import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { DeviceScene } from 'scenes';

class DeviceContainer extends AbstractContainer {

  getTasks(params) {

    const id = params.device;

    return [
      {
        key: 'device',
        exec: (done, failure) => {
          API.get(`devices/${id}`)
            .then((response) => {
              let device = {
                ...response.data,
                id: id
              };

              done(device);
            })
            .catch(failure);
        }
      },
      {
        key: 'remotes',
        exec: (done, failure) => {
          API.get(`devices/${id}/remotes`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <DeviceScene {...results} />
  }
}

export default DeviceContainer;
